import _ from 'underscore';


/**
 * Update status property for filter
 *
 * @param {Object} entitySchema - the option to update for filter
 * @returns {void}
*/
export function updateStatusPropertyForFilter(entitySchema) {
  const statusProperty = entitySchema.properties.Status;
  let deleteIndex = -1;

  if (statusProperty && _.isArray(statusProperty.enum)) {
    _.each(statusProperty.enum, (value, index) => {
      if (value.indexOf('Delete') > -1) {
        deleteIndex = index;
      }
    });
    if (deleteIndex > 0) {
      statusProperty.enum.splice(deleteIndex, 1);
    }
  }
  return statusProperty;
}

